/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import OTPInput, { ResendOTP } from "otp-input-react";
import { virifyOtp } from './api';
import Swal from 'sweetalert2';




/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/


export function NewUserVirification({ returnFunction = null, mobile, closePOup, title = "Verification", description = "OTP send", reSendOtp, headerImage = true, setFieldValue, withoutOtp = false }) {
    const [timerKey, setTimerKey] = useState(0);
    const [loading, setLoading] = useState(false)
    const [OTP, setOTP] = useState("");
    const [status, setStatus] = useState('');
    const [skipOtp, setSkipOtp] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        // If user chose to skip OTP, confirm and call returnFunction
        if (skipOtp) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to confirm the address without OTP?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                reverseButtons: true,
                customClass: {
                    confirmButton: 'btn btn-danger',
                    cancelButton: 'btn btn-secondary',
                },
                buttonsStyling: false,
            }).then((result) => {
                // ❌ Cancel clicked → do nothing
                if (!result.isConfirmed) return;

                // ✅ Confirm clicked
                if (returnFunction) {
                    setFieldValue('skip_otp', 'The user did not provide the OTP');
                    setSkipOtp(false);
                    returnFunction(1);

                }
            });
            return;
        }


        setLoading(true)

        setTimeout(() => {
            virifyOtp({ mobile: mobile, otp: OTP }).then(({ data }) => {

                if (Number(data.code) === 0) {
                    setStatus(data?.message);
                    setLoading(false)
                    if (returnFunction) {
                        // returnFunction(1)
                    }
                } else {
                    if (returnFunction) {
                        returnFunction(1);
                    }
                    setStatus(data?.message);
                }
            }).catch(() => {
                setLoading(false)
                setStatus('Something wrong!')
            })
        }, 1000)

    }
    const renderButton = (buttonProps) => {
        return buttonProps.remainingTime !== 0 ? `Please wait for ${buttonProps.remainingTime} sec` : <> <span className="text-muted  me-1">Didn’t get the code ?</span>
            <button type={'button'}  {...buttonProps} onClick={() => handleResendOTP()} className="btn btn-sm btn-primary">Resend</button></>
    };

    const renderTime = () => React.Fragment;
    const handleResendOTP = () => {
        reSendOtp();
        setTimerKey((prev) => prev + 1);
    };

    return (
        <>
            <div className={`mx-auto ${headerImage === true ? '' : 'text-center'}`} >
                <form
                    className='form w-100'
                    onSubmit={handleSubmit}
                    noValidate
                >
                    <div className="mb-3">
                        <div className="bg-white d-flex flex-column  w-100" style={{ maxWidth: "800px" }}>
                            {headerImage &&
                                <div className='d-flex justify-content-center w-100'>
                                    <img width="220" alt="icon" src={"/media/images/new-otp.png"} className="mb-4" />
                                </div>
                            }
                            <h2 className="mb-3">{title}</h2>
                            <p className="text-gray-600">{description}</p>
                        </div>
                        {status !== "" &&
                            <div className="text-danger fw-semibold fs-5 mb-5">{status}</div>
                        }
                    </div>
                    <div className={`mb-10 ${headerImage === true ? '' : 'text-center'}`}>
                        {/* begin::Label */}
                        <div className="fw-semibolder text-start text-dark fs-6 mb-1 ms-1">Type your 4 digit otp code</div>
                        {/* end::Label */}
                        {/* begin::Input group */}
                        <div className="d-flex flex-wrap flex-stack">
                            <OTPInput
                                value={OTP} onChange={setOTP}
                                inputClassName={`form-control form-control-solid  h-60px w-60px fs-2qx text-center border-primary border-hover mx-1 my-2`}
                                autoFocus OTPLength={4}
                                otpType="number"
                                disabled={skipOtp} />

                        </div>
                        {/*begin::Input group*/}
                    </div>
                    {/* begin::Heading */}
                    {withoutOtp && <div className="mb-4 text-start">
                        <div className="form-check">
                            <input
                                type="checkbox"
                                id="skip_otp"
                                name="skip_otp"
                                className="form-check-input"
                                checked={skipOtp}
                                onChange={(e) => { setSkipOtp(e.target.checked); setOTP(''); }}
                            />
                            <label
                                htmlFor="skip_otp"
                                className="form-check-label fw-semibold text-muted fs-6"
                            >
                                Address confirmed without OTP
                            </label>
                        </div>
                    </div>
                    }
                    {/* begin::Action */}
                    <div className='text-center'>
                        <div className='d-flex flex-stack'>
                            <button
                                type='button'
                                id='kt_cancell_in_submit'
                                className='btn btn-lg w-100 mb-5 me-3'
                                style={{ background: '#0E295E' }}
                                //disabled={loading}
                                onClick={() => closePOup()}
                            >
                                <span className='indicator-label text-white'>Cancel</span>
                            </button>
                            <button
                                type='submit'
                                id='kt_otp_in_submit'
                                className='btn btn-lg btn-primary w-100 mb-5'
                                disabled={!OTP && !skipOtp}
                            >
                                {!loading && <span className='indicator-label'>Continue</span>}
                                {loading && (
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        Please wait...
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>
                                )}
                            </button>
                        </div>
                        <div className="text-center align-items-center fw-semibold fs-5">
                            <ResendOTP key={timerKey} maxTime={90} onTimerComplete={() => console.log('Timer ended')} renderButton={renderButton} renderTime={renderTime} />
                            {/*<span className="text-muted me-1">Didn’t get the code ?</span> <a href="#" onClick={() => ResendOTP()} className="link-primary fw-semibolder fs-5 me-1">Resend</a> */}
                        </div>
                    </div>
                </form>
            </div >
        </>
    )
}